











import {Writeable} from "@/interfaces/Writeable";
import {Component, Prop, Vue} from "vue-property-decorator";
import SaveCancelDeleteButtonPanel from "@/componentsReusable/SaveCancelDeleteButtonPanel.vue";

@Component({
  components: {
    SaveCancelDeleteButtonPanel
  }
})
export default class SingleItemUpdatePanel extends Vue {
  @Prop({type: Object as () => Writeable})
  protected entity!: Writeable;

  protected cancel(writeable: Writeable) {
    this.$emit('cancel', writeable);
  }
  protected update(writeable: Writeable) {
    this.$emit('update', writeable);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/SingleItemUpdatePanel.vue